module.exports = __webpack_public_path__ + "img/step4.988ff7d5.gif";